module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-thumbnail.f04effb4.png";